export default "/lineup-tool/assets/redux/ajax_loader.gif";